import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActualCoverageOverallLookupComponent } from './actual-coverage-overall-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [ActualCoverageOverallLookupComponent],
  exports: [ActualCoverageOverallLookupComponent]
})
export class ActualCoverageOverallLookupModule { }
